import React, { FunctionComponent } from 'react';
import { useProperty } from '@spotify-internal/remote-config-integration-react';

import { useVerticalConfig } from 'providers/vertical';
import { usePillowTalk } from 'utils/remote-config/properties';
import { PillowTalkConfig, Vertical } from 'utils/vertical';

import { LivePersonMessagingProvider } from './LivePersonMessagingProvider';
import { PillowTalkWrapper } from './PillowTalkMessagingProvider';

interface Props {
  locale: string;
  marketCode: string;
  children: React.ReactNode;
}

const CONSUMER_PILLOW_TALK_CONFIG: PillowTalkConfig = {
  lineOfBusiness: 'CONSUMER',
  redirectUri: 'https://support.spotify.com/contact-spotify-anonymous/',
  showLoginDialog: true,
};

const MessagingProviderWrapper: FunctionComponent<Props> = ({ locale, marketCode, children }) => {
  const {
    verticalName,
    features,
    locales: { messagingLocales },
  } = useVerticalConfig();
  const usePillowTalkProperty = useProperty(usePillowTalk, { loadingValue: null });

  if (features?.configurePillowTalk) {
    return (
      <PillowTalkWrapper
        locale={locale}
        configurePillowTalk={features.configurePillowTalk}
        vertical={verticalName}
        messagingLocales={messagingLocales}
      >
        {children}
      </PillowTalkWrapper>
    );
  }

  if (usePillowTalkProperty && verticalName === Vertical.CONSUMER) {
    return (
      <PillowTalkWrapper
        locale={locale}
        configurePillowTalk={CONSUMER_PILLOW_TALK_CONFIG}
        vertical={verticalName}
        messagingLocales={messagingLocales}
      >
        {children}
      </PillowTalkWrapper>
    );
  }

  return (
    <LivePersonMessagingProvider locale={locale} marketCode={marketCode}>
      {children}
    </LivePersonMessagingProvider>
  );
};

export default MessagingProviderWrapper;
